import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M21.65 6.47l-5-4.23a1 1 0 00-1.3 0l-5 4.23a1 1 0 00-.35.76v6.27a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5V7.23a1 1 0 00-.35-.76zM20 13h-3v-2a1 1 0 00-2 0v2h-3V7.69l4-3.38 4 3.38z"/><path d="M14.31 20.81l-3.94-4.75-.09-.1A2.91 2.91 0 008 15.2v-2.7C8 9.92 6.38 9 5 9s-3 1.08-3 3.5v7.2a3.74 3.74 0 00.82 2.3L7 27.25V29a1 1 0 001 1h6a1 1 0 001-1v-6.28a3 3 0 00-.69-1.91zM13 28H9v-1.1a1 1 0 00-.22-.62l-4.4-5.51A1.67 1.67 0 014 19.7v-7.2c0-.68.17-1.5 1-1.5.25 0 1 0 1 1.5v3.85A3 3 0 006.23 20l3 3.6a1 1 0 001.54-1.28l-3-3.64a1 1 0 01-.06-1.28.86.86 0 011.2 0l3.89 4.68a1 1 0 01.23.64zM27 9c-1.38 0-3 .92-3 3.5v2.69a2.93 2.93 0 00-2.28.77l-.09.1-3.94 4.75a3 3 0 00-.69 1.91V29a1 1 0 001 1h6a1 1 0 001-1v-1.75L29.18 22a3.74 3.74 0 00.82-2.3v-7.2c0-2.42-1.51-3.5-3-3.5zm1 10.7a1.71 1.71 0 01-.38 1.08l-4.4 5.5a1 1 0 00-.22.62V28h-4v-5.28a1 1 0 01.23-.64l3.89-4.68a.84.84 0 011.14 0 1 1 0 010 1.38l-3 3.6a1 1 0 101.54 1.28l3-3.56a3 3 0 00.2-3.73V12.5c0-1.5.75-1.5 1-1.5.83 0 1 .82 1 1.5z"/>';
export var HOAOutlineSvg = function HOAOutlineSvg(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
HOAOutlineSvg.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HOAOutlineSvg);